export default "__VITE_ASSET__CVaBa5Mc__"